import React from "react";
import { AlertOctagon, RefreshCw } from "lucide-react";
import { Button } from "../ui/Button";

/**
 * A crash in one screen used to blank the whole panel. Now it is contained,
 * explained, and recoverable without losing the broker session.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Screen crashed:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // A new route gets a clean slate.
    if (this.state.error && prevProps.routeKey !== this.props.routeKey) {
      this.setState({ error: null });
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="route-enter mx-auto max-w-xl py-16">
        <div className="rounded-2xl border border-rose-500/30 bg-rose-500/[.06] p-6 text-center">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl border border-rose-500/30 bg-rose-500/[.1] text-rose-400">
            <AlertOctagon className="h-5 w-5" />
          </span>
          <h2 className="text-lg font-bold text-hi">This screen hit an error</h2>
          <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-low">
            Trading and data on the server are unaffected — only this view stopped rendering.
          </p>
          <pre className="mt-4 overflow-x-auto rounded-xl border border-line bg-surface-2 p-3 text-left font-mono text-[11px] leading-relaxed text-low">
            {String(error?.message || error)}
          </pre>
          <div className="mt-5 flex justify-center gap-2">
            <Button variant="secondary" onClick={() => this.setState({ error: null })}>
              Try again
            </Button>
            <Button variant="primary" icon={<RefreshCw className="h-4 w-4" />} onClick={() => window.location.reload()}>
              Reload panel
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
